import {mapNullToUndefined} from '../../utils/mapperHelper.utils';

export class PaymentPolicyModel {
  public subtitle?: string;
  public policy?: string;

  constructor(params: PaymentPolicyModel) {
    this.subtitle = params.subtitle;
    this.policy = params.policy;
  }

  public static fromCheckoutV1(productName?: string | null, consentRequiredPaymentPolicy?: string | null) {
    return new PaymentPolicyModel({
      subtitle: mapNullToUndefined(productName),
      policy: mapNullToUndefined(consentRequiredPaymentPolicy),
    });
  }

  /* istanbul ignore next */
  // eslint-disable-next-line sonarjs/no-identical-functions
  public static fromCartV2(productName?: string | null, consentRequiredPaymentPolicy?: string | null) {
    return new PaymentPolicyModel({
      subtitle: mapNullToUndefined(productName),
      policy: mapNullToUndefined(consentRequiredPaymentPolicy),
    });
  }
}
